import { Checkbox, Icon, TableCell, TableRow, Tooltip } from '@material-ui/core';
import Truncate from 'components/Truncate';
import React from 'react';
import { FormattedNumber } from 'react-intl';
import useBoolean from 'v2/hooks/useBoolean';

import { useStyles } from './styles';

import type IAnticipation from 'interfaces/IAnticipation';

type TransactionRowProps = {
  invoice: IAnticipation;
  isNotSelected: boolean;
  handleChangeSelectCommission: (item: IAnticipation, selectedCommisions: number) => void;
  handleChangeSelectInvoice: (item: IAnticipation) => void;
};

const TOOLTIP_MESSAGE_COMMISSION_UNMARKABLE =
  'Essa comissão já está selecionada e não pode ser desmarcada. O produto associado não está disponível para antecipação de recebimento por parcelas.';

function TransactionRow({ invoice, isNotSelected, handleChangeSelectCommission, handleChangeSelectInvoice }: TransactionRowProps) {
  const classes = useStyles();
  const [viewCommisionsList, setViewCommisionsList] = useBoolean(false);

  const commissionsList = invoice.commissions;
  const hasOnlyOneCommision = commissionsList.length === 1;
  const showCommissionList = !hasOnlyOneCommision && !!viewCommisionsList;
  const commissionsSelected = commissionsList.filter((commission) => commission.selected).length;
  const invoiceCheckboxIndeterminate = commissionsSelected && commissionsSelected < commissionsList.length;

  return (
    <>
      <TableRow>
        <TableCell className={viewCommisionsList ? classes.hasCommisionItem : null} style={{ width: 20, padding: 0 }}>
          <Checkbox
            checked={invoice.selected}
            disabled={isNotSelected}
            color={'primary'}
            onChange={() => handleChangeSelectInvoice(invoice)}
            indeterminate={invoiceCheckboxIndeterminate || null}
          />
        </TableCell>

        <TableCell className={viewCommisionsList ? classes.hasCommisionItem : null} scope='row'>
          <div className={classes.commisionsDescription}>
            <span
              style={{ cursor: hasOnlyOneCommision ? 'pointer' : 'default' }}
              onClick={hasOnlyOneCommision ? setViewCommisionsList.toggleValue : null}
            >
              <Truncate style={{ display: 'inline' }} count={25} final={'...'}>
                {invoice.description}
              </Truncate>
              {` - FAT ${invoice.id}`}
            </span>

            {!hasOnlyOneCommision && (
              <Icon
                className={classes.arrowIcon}
                onClick={setViewCommisionsList.toggleValue}
                style={{ transform: viewCommisionsList ? 'rotate(180deg)' : 'rotate(0deg)' }}
              >
                keyboard_arrow_down
              </Icon>
            )}
          </div>
        </TableCell>

        <TableCell className={viewCommisionsList ? classes.hasCommisionItem : null} align='right' style={{ padding: '0 10px 0 0' }}>
          <FormattedNumber value={invoice.gain} format='BRL' />
        </TableCell>
      </TableRow>

      {showCommissionList &&
        commissionsList.map((commission) => {
          return (
            <TableRow key={commission.description} className={classes.commisionItem}>
              <TableCell style={{ width: 20, padding: 0 }}>
                <Tooltip title={!!commission.selected && !commission.isSelectable ? TOOLTIP_MESSAGE_COMMISSION_UNMARKABLE : ''}>
                  <Checkbox checked={!!commission.selected} color={'primary'} onChange={() => handleChangeSelectCommission(invoice, commission.id)} />
                </Tooltip>
              </TableCell>

              <TableCell scope='row'>
                {`${commission.id} - `}
                {commission.description}
              </TableCell>

              <TableCell align='right'>
                <FormattedNumber value={commission.gain} format='BRL' />
              </TableCell>
            </TableRow>
          );
        })}
    </>
  );
}

export default TransactionRow;
